export const dayNightScene = [
  '691fc3199d4e2e854cdc3311',
  '691fcb2c9d4e2e854cdc39d2',
  '691fc3099d4e2e854cdc32ed',
  '691fcb159d4e2e854cdc39ba',
];
